import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";
import {OddsByWidgetStore} from "./odds-by-widget.store";
import {OddsByWidgetHandlers} from "./handlers/odds-by-widget.handlers";
import {OddsByWidgetConfig} from "./odds-by-widget.config";

export class OddsByWidgetController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, OddsByWidgetConfig, OddsByWidgetStore, OddsByWidgetHandlers];
}
